import type { companies as en } from '@/i18n/locales/en/companies';
import type { Translation } from '@/i18n/types';

export const companies: Translation<typeof en> = {
  list: {
    title: 'Εταιρείες',
    newCompany: 'Νέα εταιρεία',
    empty: 'Δεν υπάρχουν εταιρείες ορατές σε εσάς.',
    name: 'Όνομα',
    created: 'Δημιουργήθηκε',
    rowsLabel: 'τις εταιρείες',
    healthTitle: 'Υγεία οργανισμού',
    healthCompanies: 'Εταιρείες',
    healthEditions: 'Εκδόσεις',
    healthPilots: 'Πιλοτικά',
    healthPilotsLabel: 'τη σύνοψη πιλοτικών',
    healthActivePilotCount: '{{count}} εταιρείες με ενεργό πιλοτικό',
  },
  detail: {
    thisCompany: 'εταιρεία',
    rename: 'Μετονομασία',
    companyAdmins: 'Διαχειριστές εταιρείας',
    delete: 'Διαγραφή',
    departmentsTitle: 'Τμήματα',
    newDepartment: 'Νέο τμήμα',
    departmentsEmpty: 'Δεν υπάρχουν ακόμη τμήματα.',
    departmentsLabel: 'τα τμήματα',
    name: 'Όνομα',
    statistics: 'Στατιστικά',
    collectiveConsent: 'Συλλογική συγκατάθεση',
    inForce: 'σε ισχύ',
    settingsTitle: 'Ρυθμίσεις',
    settingsLabel: 'τις ρυθμίσεις',
    change: 'Αλλαγή',
    minGroupSizeLabel: 'Ελάχιστο μέγεθος ομάδας για συγκεντρωτικά στοιχεία:',
    systemDefault: 'προεπιλογή συστήματος',
    companyOverride: 'παράκαμψη εταιρείας',
    domainsTitle: 'Τομείς email',
    domainsLabel: 'τους τομείς',
    manage: 'Διαχείριση',
    domainsEmpty: 'Δεν έχουν καταχωριστεί τομείς.',
    membersTitle: 'Μέλη',
    membersLabel: 'τα μέλη',
    addPerson: 'Προσθήκη ατόμου',
    membersEmpty: 'Δεν υπάρχουν μέλη.',
    email: 'Email',
    login: 'Σύνδεση',
    source: 'Προέλευση',
    actions: 'Ενέργειες',
    yes: 'ναι',
    no: 'όχι',
  },
  form: {
    newTitle: 'Νέα εταιρεία',
    name: 'Όνομα',
    cancel: 'Ακύρωση',
    create: 'Δημιουργία εταιρείας',
    editTitle: 'Μετονομασία εταιρείας',
    save: 'Αποθήκευση',
    deleteTitle: 'Διαγραφή εταιρείας',
    deleteLead:
      'Η διαγραφή του {{name}} τερματίζει και τους τομείς και τις εγγραφές συμμετοχής του. Αυτό δεν μπορεί να αναιρεθεί. Πληκτρολογήστε το όνομα της εταιρείας για επιβεβαίωση.',
    companyNameLabel: 'Όνομα εταιρείας',
    deletePermanently: 'Οριστική διαγραφή',
    settingsTitle: 'Όριο συγκεντρωτικών στοιχείων',
    settingsLead:
      'Το ελάχιστο μέγεθος ομάδας κάτω από το οποίο δεν εμφανίζονται συγκεντρωτικά στοιχεία. Αφήστε κενό για επιστροφή στην προεπιλογή του συστήματος. Το API επιβάλλει ένα απόλυτο κατώτατο όριο.',
    minGroupSize: 'Ελάχιστο μέγεθος ομάδας',
    domainsTitle: 'Τομείς email',
    domainsLead:
      'Μια επαληθευμένη διεύθυνση σε έναν από αυτούς τους τομείς εγγράφει τον κάτοχό της σε αυτή την εταιρεία κατά τη σύνδεση. Οι υπάρχουσες συμμετοχές παραμένουν όταν αφαιρείται ένας τομέας.',
    remove: 'Αφαίρεση',
    addDomain: 'Προσθήκη τομέα',
    add: 'Προσθήκη',
    backToCompany: 'Επιστροφή στην εταιρεία',
  },
  health: {
    title: 'Υγεία οργανισμού',
    edition: 'Έκδοση',
    editionFit: 'Fit',
    editionSoccer: 'Soccer',
    members: 'Μέλη',
    pilotsTitle: 'Πιλοτικά',
    pilotsLabel: 'την κατάσταση πιλοτικών',
    noPilots: 'Δεν υπάρχουν ακόμη πιλοτικά.',
    activeCount: '{{count}} ενεργά',
    scaledCount: '{{count}} σε κλιμάκωση',
    totalCount: '{{count}} σύνολο',
    viewAllPilots: 'Προβολή όλων των πιλοτικών',
  },
};
